/**
 * Format package code with dashes for display
 * @param {string} code - The package code to format
 * @returns {string} Formatted package code (e.g., "123 - 456 - 789")
 */
const formatPackageCode = (code) => {
    if (!code) {
        return '';
    }
    return code.replace(/(\d{3})(\d{3})(\d{3})/, '$1 - $2 - $3');
};
export default formatPackageCode;